import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = unknown, false = not authed, obj = authed
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/me");
      setAdmin(data);
    } catch {
      setAdmin(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    try {
      const body = email ? { email, password } : { password };
      const { data } = await api.post("/admin/login", body);
      if (data.token) localStorage.setItem("rrdc_admin_token", data.token);
      await check();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const logout = async () => {
    try {
      await api.post("/admin/logout");
    } catch (_e) {
      // ignore
    }
    localStorage.removeItem("rrdc_admin_token");
    setAdmin(false);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, loading, login, logout, refresh: check }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
